export default __webpack_public_path__ + "static/media/performance-products.3164cd0b.svg";